import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m16.95 20.65 1.15-1.15-1.6-1.6-1.15 1.15q-.35.35-.35.8t.35.8.8.35.8-.35m2.55-2.55 1.15-1.15q.35-.35.35-.8t-.35-.8-.8-.35-.8.35L17.9 16.5zm-1.125 3.975A3.03 3.03 0 0 1 16.15 23a3.03 3.03 0 0 1-2.225-.925A3.03 3.03 0 0 1 13 19.85q0-1.3.925-2.225l3.7-3.7A3.03 3.03 0 0 1 19.85 13q1.3 0 2.225.925C23 14.85 23 15.283 23 16.15s-.308 1.608-.925 2.225zM5 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.413A1.93 1.93 0 0 1 5 3h4.2a3 3 0 0 1 1.088-1.45A2.86 2.86 0 0 1 12 1q.95 0 1.713.55.762.55 1.087 1.45H19q.824 0 1.413.587.586.589.587 1.413v6.125A4 4 0 0 0 20 11q-.5 0-1 .075V5H5v14h6.075Q11 19.5 11 20t.125 1zm7-16.75a.73.73 0 0 0 .75-.75.73.73 0 0 0-.75-.75.73.73 0 0 0-.75.75.73.73 0 0 0 .75.75M7 9V7h10v2zm0 4v-2h10v.85q-.2.125-.387.287-.188.163-.388.363l-.5.5zm0 4v-2h6.725L12.5 16.225a8 8 0 0 0-.363.387 3 3 0 0 0-.287.388z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }